// ¿UNA COMIDA FAVORITA ENTRA CON SUS CANTIDADES, SIN RECUADRAR? (Jesús Díaz, grupo «Team
// Calculadora», 29-09: «cuando cargo una comida de mis favoritas me carga los alimentos pero
// cambia todas las cantidades. Aunque incluso tuviera marcado Manual, lo cambia a automático»).
//
// Su «Batido C1 Entreno» (48 P · 47 H · 12 G) iba a una Comida 1 de 47,5 P · 48 H · 12 G: ya
// cuadraba, y el recuadre la dejó en 490 g de queso batido y 10 g de whey. Recuadrar sigue
// siendo lo que toca cuando la favorita viene de una comida con otro objetivo (JDG, Trello
// 21-09: «no sale cuadrada directamente»), pero no cuando ya cuadra ni en Manual.
//
// Devuelve el motivo para ponerla tal cual ('manual' | 'ya_cuadra') o null si hay que cuadrarla.

import { permiteMedia } from './pasoDeCantidad';

const MACROS = ['P', 'H', 'G'];

// LAS UNIDADES, ENTERAS (Jesús, 01-10, con captura: «aceite de oliva virgen extra una
// cucharadita de café» puesta a 0,5 · 2 g). Las favoritas que vinieron de Calma guardan los
// alimentos por unidades en gramos sueltos (1,7 g, 2,1 g de la cucharadita) y, desde que la
// favorita entra con sus cantidades (29-09), llegaban así a la comida sin pasar por el
// redondeo del motor. Aquí se redondean a unidades enteras, al menos una (medias solo en los
// que las admiten, como en `redondeo_salida`), y sus macros se recalculan en proporción.
export function unidadesEnteras(alimentos) {
    return (alimentos || []).map((a) => {
        const racion = Number(a?.racion || a?.peso_unidad) || 0;
        const gramos = Number(a?.cantidad_g) || 0;
        if (!(a?.unidades || a?.por_unidad) || racion <= 0 || gramos <= 0) return a;
        const u = gramos / racion;
        const redondas = permiteMedia(a) ? Math.max(0.5, Math.round(u * 2) / 2) : Math.max(1, Math.round(u));
        if (Math.abs(redondas - u) < 1e-9) return a;
        const nuevos = redondas * racion;
        const factor = nuevos / gramos;
        const macros = a.macros_efectivos
            ? Object.fromEntries(Object.entries(a.macros_efectivos).map(([k, v]) => [k, (Number(v) || 0) * factor]))
            : a.macros_efectivos;
        return { ...a, cantidad_g: nuevos, ...(macros ? { macros_efectivos: macros } : {}) };
    });
}

export function sumaDeMacros(alimentos) {
    const lista = alimentos || [];
    if (!lista.length || lista.some((a) => !a?.macros_efectivos)) return null;
    return lista.reduce((t, a) => ({
        P: t.P + (Number(a.macros_efectivos.P) || 0),
        H: t.H + (Number(a.macros_efectivos.H) || 0),
        G: t.G + (Number(a.macros_efectivos.G) || 0),
    }), { P: 0, H: 0, G: 0 });
}

export function entraTalCual({ alimentos, objetivo, modo, margen }) {
    if (modo === 'manual') return 'manual';
    const suma = sumaDeMacros(alimentos);
    if (!suma || !objetivo) return null;
    const cuadra = MACROS.every((m) => Math.abs(suma[m] - (Number(objetivo[m]) || 0)) <= margen);
    return cuadra ? 'ya_cuadra' : null;
}
